/**
 * Humanizes a program slug into a readable name — e.g. 'next-steps-p1' ->
 * 'Next Steps Part 1', 'growth-track' -> 'Growth Track'. Spells out a part
 * number segment ('p1') rather than leaving the raw abbreviation, since this
 * is what a member or leader actually sees when the real name hasn't loaded.
 */
export function humanizeProgramSlug(slug) {
  return (slug || '')
    .split('-')
    .map(word => {
      const part = word.match(/^p(\d+)$/i);
      return part ? `Part ${part[1]}` : word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(' ');
}

/**
 * Resolves a program's display name: the real name from the loaded program
 * list when available, otherwise humanizeProgramSlug as a fallback for a
 * cold render before that list has fetched.
 */
export function resolveProgramName(programs, slug) {
  const program = (programs || []).find(p => p.slug === slug);
  if (program?.name) return program.name;
  return humanizeProgramSlug(slug);
}
